import { render } from "./CompetitionDateTab.vue?vue&type=template&id=b3aec6ea"
import script from "./CompetitionDateTab.vue?vue&type=script&lang=js"
export * from "./CompetitionDateTab.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1350238635/src/wfyt-leaderboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__